
import {fromEvent as observableFromEvent,  Observable } from 'rxjs';

import {debounceTime} from 'rxjs/operators';
import { DisposableSafelly } from './../../disposable-safelly/disposable-safelly.component';
import { Component, ViewChild, ElementRef, Renderer2, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UtilitiesService } from '../../../services/utilities.service';

@Component({
    selector: 'user-message-input',
    styleUrls: ['./user-message-input.component.scss'],
    template: `
        <div #userMessageInput class="user-message-input">

            <!-- BOTÃO DE ENVIO DE MSGs -->
            <div #chatAssessorInputContainer class="user-message-input--container">

                <textarea [disabled]="disabled" rows="1" #inputSendMessage (focus)="focusIn($event)" (focusout)="focusOut($event)" placeholder="Escreva sua mensagem..."></textarea>

                <button #btnSendMessage (click)="sendMessage()" class="btn btn--sm btn--solid btn-primary--solid btn-disabled">
                    <span class="hidden-xs">
                        Enviar mensagem
                    </span>

                    <span class="visible-xs">
                        <svg class="icon-svg">
                            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/assets/images/icons/all-icons.svg#icon_chevron_right"></use>
                        </svg>
                    </span>
                </button>
            </div>

            <!-- BOTÃO PARA RESETAR O CHAT -->
            <div class="user-message-input--reset">
                <a (click)="goToAttendence()" class="btn btn--sm btn--solid btn-primary--solid">
                    Tela de atendimento
                </a>

                <a (click)="tryAssessorChat()" class="btn btn--sm btn--solid btn-primary--solid">
                    Reiniciar chat com assessor
                </a>
            </div>
        </div> `
})
export class UserMessageInputComponent extends DisposableSafelly implements OnInit {

    @ViewChild('userMessageInput', {static: true}) userMessageInput;

    @ViewChild('chatAssessorInputContainer', {static: true}) chatAssessorInputContainer;
    @ViewChild('inputSendMessage', {static: true}) inputSendMessage: ElementRef;
    @ViewChild('btnSendMessage', {static: true}) btnSendMessage;

    @Output() userMessangeEmmiter: EventEmitter<any> = new EventEmitter();
    @Output() userTypingMessangeEmmiter: EventEmitter<any> = new EventEmitter();
    @Input() disabled: boolean = true;

    private onEnterPressEvent;

    private checkTextAreaInterval;

    public valueTyping: string = '';

    constructor(
        private _R: Renderer2,
        private ut: UtilitiesService,
        private router: Router
    ) {
        super();
    }

    ngOnInit() {
        this.disposableSubscriptions.push(
            observableFromEvent(this.inputSendMessage.nativeElement, 'keyup').pipe(debounceTime(500)).subscribe((data) => {
                let inputValue = this.inputSendMessage.nativeElement.value,
                    positionText = 0;

                if (inputValue.length) {
                    this.userTypingMessangeEmmiter.emit({ message: inputValue, position: positionText, type: 'User', id: this.ut.guid() });
                }
            })
        );
    }

    sendMessage() {
        // devolve o foco para o input apos o envio
        this.inputSendMessage.nativeElement.focus();

        // recebe o texto digitado no input
        let inputValue = this.inputSendMessage.nativeElement.value;

        if (inputValue.length > 1) {
            this.userMessangeEmmiter.emit({ message: inputValue, type: 'User', id: this.ut.guid() });
            this.inputSendMessage.nativeElement.value = '';
        }
        else{
            this.inputSendMessage.nativeElement.value = '';
        }

        this._R.setStyle(this.userMessageInput.nativeElement, 'height', '79px');
    }

    focusIn($e) {
        this.activeInput();
        this.startObservableTextArea();
        this.onEnterPressEvent = this._R.listen(this.inputSendMessage.nativeElement, 'keyup', ($event) => {
            if ($event.keyCode == 13) {
                this.sendMessage();
            }
        });
    }

    focusOut($e) {
        this.disabledInput();
        this.onEnterPressEvent();
        this.stopObservableTextArea();
        let inputValue = this.inputSendMessage.nativeElement.value;
        if (!inputValue) {
            this._R.setStyle(this.userMessageInput.nativeElement, 'height', '79px')
        }
    }

    activeInput() {
        this._R.addClass(this.chatAssessorInputContainer.nativeElement, 'active');
        this._R.removeClass(this.btnSendMessage.nativeElement, 'btn-disabled');
    }

    disabledInput() {
        this._R.removeClass(this.chatAssessorInputContainer.nativeElement, 'active');
        this._R.addClass(this.btnSendMessage.nativeElement, 'btn-disabled');
    }

    chatReset() {
        this.inputSendMessage.nativeElement.blur();
        this._R.addClass(this.userMessageInput.nativeElement, 'RESET');
    }

    checkExpand() {
        if (this.userMessageInput.nativeElement.clientHeight < 400) {
            if (this.userMessageInput.nativeElement.clientHeight < this.inputSendMessage.nativeElement.scrollHeight) {
                this._R.setStyle(this.userMessageInput.nativeElement, 'height', this.inputSendMessage.nativeElement.scrollHeight + 'px');
            }
        }
    }

    tryAssessorChat() {
        this.router.navigateByUrl('/atendimento/assessor');
    }

    goToAttendence() {
        this.router.navigateByUrl('/atendimento');
    }

    startObservableTextArea() {
        this.checkTextAreaInterval = window.setInterval(() => { this.checkExpand() }, 400);
    }

    stopObservableTextArea() {
        clearInterval(this.checkTextAreaInterval);
    }
}
